<template>
  <div class="container_box details_box_styles">
    <delarationDetail ref="detailFrom"></delarationDetail>
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <div class="options_box">
            <h2 class="title_box">{{ $t('key1002685') }}</h2>
            <Button type="primary" @click="addRule">{{ $t('key1001340') }}</Button>
          </div>
        </template>
        <div class="table_box">
          <Table
            highlight-row
            border
            draggable
            max-height="560"
            @on-drag-drop="dragDrop"
            :loading="tableLoading"
            :columns="tableColumns"
            :data="listData">
          </Table>
          <Page
            :transfer="true"
            v-if="!tableLoading"
            :total="total"
            @on-change="changePage"
            show-total
            :page-size="pageParams.pageSize"
            show-elevator
            :current="pageParams.pageNum"
            show-sizer
            @on-page-size-change="changePageSize"
            placement="top"
            :page-size-opts="pageArray">
          </Page>
        </div>
      </Card>
    </div>
    <ruleTemp ref="ruleTemp" :ruleType="'declaration'" @saveCallback="search"></ruleTemp>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import delarationDetail from "./delarationDetail";
import ruleTemp from '@/components/common/ruleTemp';
import {getAllUsersInfo, getUserNameByUserId} from "@/utils/common";

export default {
  name: "declarationRules",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [
        {
          title: 'No',
          width: 70,
          align: 'center',
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002152'),
          width: 200,
          align: 'center',
          render: (h, params) => {
            let arr = [
              h('span', {
                attrs: {
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002153')
                },
                domProps: {
                  innerHTML: '&#xe68a;'
                },
                class: 'icon iconfont cursor normalFontSizeTwoSize greenColor',
                on: {
                  click: () => {
                    v.tableSort(params.row.autoRuleId, v.listData.length - 1, params.index);
                  }
                }
              }),
              h('span', {
                attrs: {
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002154')
                },
                domProps: {
                  innerHTML: '&#xe687;'
                },
                class: 'icon iconfont cursor normalFontSizeTwoSize blueColor',
                on: {
                  click: () => {
                    v.tableSort(params.row.autoRuleId, 0, params.index);
                  }
                }
              }),
              h('Icon', {
                props: {
                  type: 'md-move',
                  size: 18
                },
                attrs: {
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002155')
                },
                style: {
                  marginLeft: '5px',
                  position: 'relative',
                  top: '-2px'
                },
                class: 'cursor-move grayColor'
              })
            ];
            if (params.index === 0) {
              arr.splice(1, 1);
            } else if (params.index === v.listData.length - 1) {
              arr.splice(0, 1);
            }
            if (v.listData.length > 1) {
              return v.getPermission('ymsPackageDeclareAutoRule_updatePriority') ? h('div', {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }
              }, arr) : '';
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002156'),
          minWidth: 180,
          align: 'center',
          key: 'name'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          width: 130,
          align: 'center',
          render: (h, params) => {
            return params.row.status === 0 ? h('span', {
              class: 'redColor'
            }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')) : h('span', {
              class: 'greenColor'
            }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002158'),
          align: 'center',
          minWidth: 100,
          key: 'createdBy',
          render: (h, params) => {
            return h('span', getUserNameByUserId(params.row.createdBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002683'),
          minWidth: 200,
          align: 'center',
          key: 'createdTime',
          sortable: true,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'operate',
          align: 'center',
          width: 160,
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsPackageDeclareAutoRule_update'),
                    clickFn: () => {
                      v.ruleTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002684') + '(' + params.row.name + ')';
                      v.ruleEditStatus = true;
                      v.$nextTick(function () {
                        v.ruleEditModel = true;
                        v.ruleParmas = {
                          editType: 'edit',
                          type: 0, // 0 warehose edit 1 audit create 2 audit edit
                          autoRuleId: params.row.autoRuleId,
                          warehouseId: params.row.warehouseId,
                          name: params.row.name,
                          status: params.row.status,
                          businessId: params.row.businessId
                        };
                        v.$refs.ruleTemp.open(v.ruleParmas);
                      });
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: params.row.status === 0 && v.getPermission('ymsPackageDeclareAutoRule_enable'),
                    clickFn: () => {
                      v.setStatus(params.row.autoRuleId, 0);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: params.row.status === 1 && v.getPermission('ymsPackageDeclareAutoRule_disable'),
                    clickFn: () => {
                      v.setStatus(params.row.autoRuleId, 1);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      listData: [],
      ruleParmas: {
        type: 2, // 0 warehose edit 1 audit create 2 audit edit
        name: '', // 规则名
        autoRuleId: null,
        status: null,
        editType: 'add',
        businessId: '',
        userInfoList: {}
      }
    };
  },
  created() {
    let v = this;
    v.initFun();
  },
  mounted() {
    this.$refs.detailFrom.getPackageRuleDetails();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      (async () => {
        await getAllUsersInfo().then((data) => {
          v.userInfoList = data;
        });
        await v.search();
      })();
    },
    // 启用停用规则
    setStatus(autoRuleId, type) {
      let v = this;
      let url;
      if (type) {
        url = api.put_ymsPackageDeclareAutoRule_disable;
      } else {
        url = api.put_ymsPackageDeclareAutoRule_enable;
      }
      v.axios.put(url + autoRuleId).then(response => {
        if (response.data.code === 0) {
          v.pageParamsStatus = true;
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
        } else {
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
        }
      });
    },
    closeModal() {
      this.ruleEditModel = false;
      this.getList();
      this.$refs.detailFrom.getPackageRuleDetails();
    },
    addRule() {
      this.ruleParmas.editType = 'add';
      this.ruleParmas.autoRuleId = null;
      this.ruleParmas.status = 0;
      this.ruleParmas.name = '';
      this.timestamp = new Date().getTime();
      this.ruleParmas.businessId = null;
      this.$refs.ruleTemp.open(this.ruleParmas);
    },
    dragDrop(a, b) {
      this.tableSort(this.listData[a].autoRuleId, b, a);
    },
    tableSort(autoRuleId, index, oldIndex) {
      let v = this;
      let obj = {
        currentId: autoRuleId, // 规则ID
        previousId: index ? v.listData[index].autoRuleId : null, // 前一个
        businessId: v.listData[oldIndex].businessId
      };
      if (!index && v.listData.length > 1) {
        obj.nextId = v.listData[0].autoRuleId;
      }

      if (oldIndex > index) {
        obj = {
          currentId: v.listData[oldIndex].autoRuleId, // 规则ID
          businessId: v.listData[oldIndex].businessId,
          previousId: index > 0 ? v.listData[index - 1].autoRuleId : null
        };
        if (index >= 0 && index !== v.listData.length - 1) {
          obj.nextId = v.listData[index + 1].autoRuleId;
        }
      } else {
        obj = {
          currentId: v.listData[oldIndex].autoRuleId, // 规则ID
          businessId: v.listData[oldIndex].businessId,
          previousId: index > 0 ? v.listData[index].autoRuleId : null
        };
        if (index >= 0 && index !== v.listData.length - 1) {
          obj.nextId = v.listData[index + 1].autoRuleId;
        }
      }

      v.axios.put(api.put_ymsPackageDeclareAutoRule_updatePriority, JSON.stringify(obj)).then(response => {
        if (response.data.code === 0) {
          v.pageParamsStatus = true;
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
        }
      });
    },
    // 查询
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    getList() {
      let v = this;
      v.listData = [];
      v.total = 0;
      if (v.getPermission('ymsPackageDeclareAutoRule_query')) {
        v.axios.post(api.post_ymsPackageDeclareAutoRule_query, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            let list = data.list || [];
            v.total = data.total;
            list.forEach((n, i) => {
              n.sortIndex = i;
            });
            v.listData = list;
            v.$nextTick(() => {
              v.tableLoading = false;
            });
          }
        }).catch(() => {
          v.tableLoading = false;
        });
      } else {
        v.gotoError();
      }
    },
    // 移动后逻辑处理
    endFunc(e) {
      let v = this;
      const oldIndex = e.oldIndex;
      const newIndex = e.newIndex;
      let obj;
      if (oldIndex === newIndex) {
        return false;
      }
      if (oldIndex > newIndex) {
        obj = {
          currentId: v.listData[oldIndex].autoRuleId, // 规则ID
          businessId: v.listData[oldIndex].businessId,
          previousId: newIndex > 0 ? v.listData[newIndex - 1].autoRuleId : null // 因为listData并没有更新，所以newIndex取的是原来的位置
        };
        if (newIndex >= 0 && newIndex !== v.listData.length - 1) {
          obj.nextId = v.listData[newIndex + 1].autoRuleId;// 因为listData并没有更新，所以newIndex取的是原来的位置
        }
      } else {
        obj = {
          currentId: v.listData[oldIndex].autoRuleId, // 规则ID
          businessId: v.listData[oldIndex].businessId,
          previousId: newIndex > 0 ? v.listData[newIndex].autoRuleId : null // 因为listData并没有更新，所以newIndex取的是原来的位置
        };
        if (newIndex >= 0 && newIndex !== v.listData.length - 1) {
          obj.nextId = v.listData[newIndex + 1].autoRuleId;// 因为listData并没有更新，所以newIndex取的是原来的位置
        }
      }
      v.axios.put(api.put_ymsPackageDeclareAutoRule_updatePriority, JSON.stringify(obj)).then(response => {
        if (response.data.code === 0) {
          if (newIndex === 0 || newIndex === v.listData.length - 1) {
            v.pageParamsStatus = true;
          }
          v.listData[oldIndex].sortIndex = newIndex;
          v.listData[newIndex].sortIndex = oldIndex;
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
        }
      }).catch(() => {
        v.pageParamsStatus = true;
      });
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    delarationDetail,
    ruleTemp
  }
};
</script>

<style lang="less" scoped>
.basic_information_box {
  .options_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .table_box /deep/ .ivu-table-cell {
    .greenColor {
      color: #3cb034;
    }

    .grayColor {
      color: #999999;
    }

    .blueColor {
      color: #0054A6;
    }

    .cursor {
      cursor: pointer;
    }

    .cursor-move {
      cursor: move;
    }

    .normalFontSizeTwoSize {
      font-size: 18px !important;
      margin: 0 4px;
    }
  }
}
</style>
